import React from 'react';

export interface SubTenantForm {
  id?: string;
  name: string;
  email: string;
  phone?: string;
}

interface SubTenantModalProps {
  isOpen: boolean;
  title?: string;
  description?: string;
  form: SubTenantForm;
  onChange: (updates: Partial<SubTenantForm>) => void;
  onClose: () => void;
  onSave: () => void;
  saving?: boolean;
}

const SubTenantModal: React.FC<SubTenantModalProps> = ({
  isOpen,
  title = 'Add Sub-tenant',
  description = 'Add a sub-tenant to this tenancy.',
  form,
  onChange,
  onClose,
  onSave,
  saving = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="w-full max-w-lg rounded-3xl bg-white shadow-2xl">
        <div className="border-b border-gray-100 px-6 py-4">
          <h3 className="text-xl font-bold text-gray-900">{title}</h3>
          <p className="text-sm text-gray-500">{description}</p>
        </div>
        <div className="px-6 py-6 space-y-4">
          <div className="grid gap-4 md:grid-cols-2">
            <div>
              <label className="text-sm text-gray-700">Name</label>
              <input
                value={form.name}
                onChange={(e) => onChange({ name: e.target.value })}
                placeholder="Jane Doe"
                className="mt-1 w-full rounded-md border-gray-300 px-3 py-2"
              />
            </div>
            <div>
              <label className="text-sm text-gray-700">Email</label>
              <input
                type="email"
                value={form.email}
                onChange={(e) => onChange({ email: e.target.value })}
                placeholder="jane@example.com"
                className="mt-1 w-full rounded-md border-gray-300 px-3 py-2"
              />
            </div>
            <div className="md:col-span-2">
              <label className="text-sm text-gray-700">Phone</label>
              <input
                value={form.phone ?? ''}
                onChange={(e) => onChange({ phone: e.target.value })}
                placeholder="+353..."
                className="mt-1 w-full rounded-md border-gray-300 px-3 py-2"
              />
            </div>
          </div>
          <div className="flex items-center justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="rounded-xl border border-gray-200 px-4 py-2 text-sm font-semibold text-gray-600 transition hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              onClick={onSave}
              disabled={saving}
              className="inline-flex items-center gap-2 rounded-xl bg-indigo-600 px-5 py-2 text-sm font-semibold text-white shadow-lg shadow-indigo-500/40 transition hover:scale-[1.01] disabled:opacity-50"
            >
              {saving && (
                <svg
                  className="h-4 w-4 animate-spin"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4l3-3-3-3v4a12 12 0 00-12 12h4z"
                  ></path>
                </svg>
              )}
              Save Sub-tenant
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubTenantModal;
